module.exports = __webpack_public_path__ + "static/media/service1.1581ca38.png";